import Styled, { css } from 'styled-components';

import {
  cssDeclaration,
  VALID_COLOR_DATA,
  VALID_DIMENSION_DATA,
  VALID_EDGE_STYLE_DATA
} from '../Utils';

export interface IStyledDividerProps {
  colorProp?: VALID_COLOR_DATA;
  widthProp?: VALID_DIMENSION_DATA;
  heightProp?: VALID_DIMENSION_DATA;
  marginProp?: VALID_EDGE_STYLE_DATA;
  alignSelfProp?: string;
}

export const StyledDivider = Styled.div<IStyledDividerProps>`
  ${({ theme: { themeTwo }, colorProp, widthProp, heightProp, marginProp, alignSelfProp }) => (
    css`
      /* align-self */ ${alignSelfProp && cssDeclaration(themeTwo, 'align-self', alignSelfProp)};
      /* background-color */ ${cssDeclaration(themeTwo, 'background-color', colorProp || 'black')};
      /* width */ ${widthProp ? cssDeclaration(themeTwo, 'width', widthProp) : 'width: 100%'};
      /* height */ ${heightProp ? cssDeclaration(themeTwo, 'height', heightProp) : 'height: 2px'};
      /* margin */ ${marginProp && cssDeclaration(themeTwo, 'margin', marginProp)};
    `
  )}
`;
